/* eslint-disable no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import * as thunks from './thunks';
import { CommonCustomerPaymentPayload, CustomerPaymentState } from './types';

const initialState: CustomerPaymentState = {
  params: {
    page: 1
  },
  customer_computation_state: {
    is_loading: false,
    computation: {}
  },
  customer_payment_list_state: {
    is_loading: false,
    list: [],
    meta: {},
    links: {}
  }
};

const slice = createSlice({
  name: 'customer-payment',
  initialState,
  reducers: {
    paramsAction(state, action: PayloadAction<CommonCustomerPaymentPayload>) {
      state.params = action?.payload;
    }
  },
  extraReducers(builder) {
    builder?.addCase(thunks?.customerPaymentListThunk?.rejected, (state) => {
      state.customer_payment_list_state.is_loading = false;
    });
    builder?.addCase(thunks?.customerPaymentListThunk?.pending, (state) => {
      state.customer_payment_list_state.is_loading = true;
    });
    builder?.addCase(
      thunks?.customerPaymentListThunk?.fulfilled,
      (state, { payload }) => {
        state.customer_payment_list_state.is_loading = false;

        state.customer_payment_list_state.list =
          payload?.originalData?.data || [];

        state.customer_payment_list_state.links =
          payload?.originalData?.link || {};

        state.customer_payment_list_state.meta =
          payload?.originalData?.meta || {};
      }
    );

    builder?.addCase(
      thunks?.customerPaymentComputationThunk?.rejected,
      (state) => {
        state.customer_computation_state.is_loading = false;
      }
    );
    builder?.addCase(
      thunks?.customerPaymentComputationThunk?.pending,
      (state) => {
        state.customer_computation_state.is_loading = true;
      }
    );
    builder?.addCase(
      thunks?.customerPaymentComputationThunk?.fulfilled,
      (state, { payload }) => {
        state.customer_computation_state.is_loading = false;
        state.customer_computation_state.computation =
          payload?.originalData?.data || {};
      }
    );
  }
});

export const reducer = slice.reducer;

export const actions = { ...slice.actions, ...thunks };
